import {
    setSessionWithNsFun,
    getSessionWithNsFun
} from '@/utils/index';
import {
    payOwesList,
    payOwesTotal,
    payQueryBizConfig,
    payQueryUserInfo,
    getCommunityList,
    getCummunityInfo,
    payConfirm,
    payMethodList,
    querySchemeList,
    queryCustListByResId,
    queryBalanceTotal,
    calcMonthlyFee,
    prepayConfirm,
    prePayObj,
    queryUserProperty,
    queryResList
} from '../../api/residentBill';
import {
    fen2Yuan
} from "@/utils/filter";
import { toastError } from '../../utils';

const setSession = setSessionWithNsFun('residentbill');
const getSession = getSessionWithNsFun('residentbill');

const state = {
    openid: getSession('openid'),
    communityId: getSession('communityId') || '',
    custId: getSession('custId') || '',
    userId: getSession('userId') || '',
    houseId: getSession('houseId') || '',
    from: getSession('from') || '',
    sigeUserId: getSession('sigeUserId') || '', // 四格userId
    schemeList: getSession('schemeList') || [], // 预存方案列表
    schemeIndex: getSession('schemeIndex') || 0,
    shareUrl: getSession('shareUrl') || ''
}


const mutations = {
    SET_OPENID(state, openid) {
        setSession('openid', openid);
        state.openid = openid;
    },
    SET_COMMUNITYID(state, communityId) {
        setSession('communityId', communityId);
        state.communityId = communityId;
    },
    SET_CUSTID(state, custId) {
        setSession('custId', custId);
        state.custId = custId;
    },
    SET_USERID(state, userId) {
        setSession('userId', userId);
        state.userId = userId;
    },
    SET_HOUSEID(state, houseId) {
        setSession('houseId', houseId);
        state.houseId = houseId;
    },
    SET_FORM(state, from) {
        setSession('from', from);
        state.from = from;
    },
    SET_SIGEUSERID(state, sigeUserId) {
        setSession('sigeUserId', sigeUserId);
        state.sigeUserId = sigeUserId;
    },
    SET_SCHEMELIST(state, schemeList) {
        setSession('schemeList', schemeList)
        state.schemeList = schemeList
    },
    MODIFY_SCHEME(state, payload) {
        const {
            index,
            value
        } = payload
        state.schemeList.splice(index, 1, value)
        setSession('schemeList', state.schemeList)
    },
    SET_SCHEMEINDEX(state, schemeIndex) {
        setSession('schemeIndex', schemeIndex)
        state.schemeIndex = schemeIndex
    },
    SET_SHAREURL(state, shareUrl) {
        setSession('shareUrl', shareUrl)
        state.shareUrl = shareUrl
    },
}

const isSpecialUser = () =>{
    // 是否是美的荟或者非3.0用户访问
    return state.from == 'mdh' || state.from == 'butler'
}

const addExtraAndSend = (api, payload) => {
    let params = {
        ...payload,
        userId: state.userId
    }
    if (state.from) {
        params.from = state.from
        if (isSpecialUser()) params.noHeadUserId = true
        // params.openid = state.openid
    }
    return api(params)
}

const actions = {
    setResidentInfo({
        commit
    }, payload) {
        const {
            communityId,
            userId,
            custId,
            houseId,
            from
        } = payload
        commit('SET_COMMUNITYID', communityId)
        commit('SET_CUSTID', custId)
        commit('SET_USERID', userId)
        commit('SET_HOUSEID', houseId)
        commit('SET_FORM', from)
    },
    // 欠费账单总额
    payOwesTotalAction({
        commit
    }, payload) {
        return addExtraAndSend(payOwesTotal, payload)
    },
    // 欠费列表
    payOwesListAction({
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            addExtraAndSend(payOwesList, payload).then(data => {
                return resolve(data.billDetail || [])
            }).catch(e => {
                reject(e)
            })
        })

    },

    // 获取预存账户
    queryCurrentCustomerAction({
        commit, state
    }, payload) {
        return new Promise((resolve, reject) => {
            addExtraAndSend(queryCustListByResId, payload).then(data => {
                const {
                    resultList
                } = data
                if (!resultList || !resultList.length) {
                    reject({
                        msg: '无预缴账户'
                    })
                } else {
                    const res = resultList[0]
                    commit('SET_CUSTID', res.custId)
                    resolve(res)
                }
            })
        })
    },

    // 四格用户信息
    payQueryUserInfoAction({
        commit
    }, payload = {}) {
        return new Promise((resolve, reject) => {
            addExtraAndSend(payQueryUserInfo, payload).then(data => {
                commit('SET_SIGEUSERID', data.userId)
                return resolve(data)
            }).catch(e => {
                reject(e)
            })
        })
    },
    payQueryBizConfigAction({
        commit
    }, payload = {}) {
        if (isSpecialUser()) {
            payload.custId = state.custId
        }
        return addExtraAndSend(payQueryBizConfig, payload)
    },
    queryUserPropertyAction({commit}, payload){
        return addExtraAndSend(queryUserProperty, payload)
    },
    getCommunityInfoAction({commit}, payload) {
        return new Promise((resolve, reject) => {
            addExtraAndSend(getCummunityInfo, payload).then(data => {
                return resolve(data.list || [])
            }).catch(e => {
                reject(e)
            })
        })
    },
    getCommunityListAction({
        commit
    }, payload = {}) {
        return new Promise((resolve, reject) => {
            addExtraAndSend(getCommunityList, payload).then(data => {
                return resolve(data.list || [])
            })
        }).catch(e => {
            reject(e)
        })
    },
    // 账单缴费付款接口
    async payConfirmAction({
        commit,
        state
    }, payload) {
        try {

            let params = {
                // 个人id信息
                wxOpenid: state.openid,
                houseId: state.houseId + '',
                userId: -1, // 四格userId
                hasSigeUserId: true,
                ruizhuUserId: state.userId + '',
                communityId: state.communityId + '',
                custId: state.custId + '',
                // 账单信息
                acctItemIds: payload.acctItemIds,
                payAmount: payload.billAmount, // 支付总金额
                disAmount: '0',
                // appId
                // system: '2048',
                wxProvider: process.env.APPID,
                // 支付方法字段
                payWay: "WEIXIN",
                // payMethod: payload.payMethodId,
                tradeType: payload.payMethodCode,
                payBzCode: "WXJS",
                disRuleIdStr: '',
                notPayLfree: "0",
                // method: "payConfirmV2",
                businessType: 10,
                show500Error: true,
                redirectUrl: `${process.env.SERVER_NAME}/resident-bill/pay-result.html`,
                channelCode: state.from == 'mdh' ? 'midea-club' : 'smart-house-keeper' // 拉起支付的入口 smart-house-keeper 管家   midea-club 美的荟
            }
            if(payload.isSelectFalsify) {
                params.notPayLfree = 1;
                params.billAmount = payload.totalFeeAmount;
            }else {
                params.notPayLfree = 0;
                params.billAmount = payload.billAmount;
            }
            if (isSpecialUser()) {
                params.noHeadUserId = true
                params.userIdNonDecrypt = true
                params.from = state.from
            }
            let res = await payConfirm(params)
            console.log('-->支付成功', res)
            return res
        } catch (e) {
            console.error('-->支付失败', e)
            throw e
        }
    },
    // 预存
    // 总预存金额
    queryBalanceTotalAction({
        commit,state
    }, payload) {
        payload.dataNoContainUserId = isSpecialUser() ? false : true
        return addExtraAndSend(queryBalanceTotal, payload)
    },
    // 预存方案列表
    querySchemeListAction({
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            addExtraAndSend(querySchemeList, payload).then(data => {
                commit('SET_SCHEMELIST', data.resultList || [])
                return resolve(data.resultList || [])
            }).catch(e => {
                reject(e)
            })
        })
    },
    // 预存月度方案计算
    // 更新预存方案的预存费用
    calcMonthlyFeeAction({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            let {
                scheme,
                index,
                resInstType,
                resInstId
            } = payload
            const {
                communityId,
                houseId,
                custId,
                from
            } = state
            addExtraAndSend(calcMonthlyFee, {
                communityId,
                custId,
                balResList: [{
                    resInstType,
                    resInstId
                }],
                balanceSchemeId: scheme.balanceSchemeId,
                dataNoContainUserId: isSpecialUser() ? false : true,
            }).then(data => {
                let newScheme
                if (data.totalFee != undefined && data.totalFee != null) {
                    const totalFee = data.totalFee / 100
                    newScheme = Object.assign(scheme, {
                        totalFee: totalFee,
                        totalFeeText: '预估费用：￥' + fen2Yuan(data.totalFee) + '/月',
                    })
                } else {
                    newScheme = Object.assign(scheme, {
                        totalFeeText: '预估费用：--',
                    })

                }
                commit('MODIFY_SCHEME', {
                    index: index,
                    value: newScheme
                })
                resolve()
            }).catch(e => {
                let newScheme = Object.assign(scheme, {
                    totalFeeText: '预估费用：--',
                })
                commit('MODIFY_SCHEME', {
                    index: index,
                    value: newScheme
                })
                resolve()
            })
        })
    },

    // 获取支付方式
    getPayMethodsAction({state}, payload) {
        return new Promise((resolve, reject) => {
            let params =  {communityId: state.communityId}
            if (isSpecialUser()) {
                params.custId = state.custId
            }
            addExtraAndSend(payMethodList, params).then(res => {
                resolve(res.payMethods || [])
            }).catch(e => {
                reject(e)
            })
        })
    },
      // 获取产权列表
      queryResList({state}, payload) {
        return new Promise((resolve, reject) => {
            addExtraAndSend(queryResList, payload).then(res => {
                resolve(res || [])
            }).catch(e => {
                reject(e)
            })
        })
    },


    async prepayConfirmAction({
        commit,
        state
    }, payload) {
        try {
            const {
                payWay
            } = prePayObj['1']
            const {
                custId,
                sigeUserId,
                houseId,
                communityId,
                userId,
                openid,
            } = state
            const {
                balanceSchemeName,
                custName,
                balanceSchemeId,
                payAmount,
                payMethodCode,
                payMethodId,
                resInstName,
                resInstId,
                resInstType
            } = payload
            const params = {
                wxOpenid: openid,
                communityId,
                userId: sigeUserId,
                // userId: '-1',
                ruizhuUserId: userId,
                hasSigeUserId: true,
                custId,
                custName,
                balResList: [{
                    resInstType,
                    resInstId,
                    resInstName,
                    resInstCode: ''
                }],
                balanceSchemeId,
                balanceSchemeName,
                wxProvider: process.env.APPID,
                payBzCode: 'WXJS',
                payMethod: payMethodId,
                tradeType: payMethodCode,
                payWay: payWay,
                payAmount: Number(payAmount),
                desc: '预缴缴费',
                businessType: 10,
                show500Error: true,
                channelCode: state.from == 'mdh' ? 'midea-club' : 'smart-house-keeper', // 拉起支付的入口  smart-house-keeper 管家   midea-club 美的荟
                redirectUrl: `${process.env.SERVER_NAME}/resident-bill/pay-result.html`,
            }
            if (state.from) {
                params.from = state.from
                if (isSpecialUser()) {
                    params.noHeadUserId = true
                    // params.sigeUserId = sigeUserId
                    params.sigeUserId = -1
                    params.userId = userId
                    delete params.ruizhuUserId
                    delete params.hasSigeUserId
                }
            }
            const res = await prepayConfirm(params)
            console.log('--> prepayConfirm 成功', res)
            return res
        } catch (err) {
            console.log('--> prepayConfirm 失败', err)
            throw err
        }

    }

}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/residentbill.js